import React, { useState, useRef, useEffect } from 'react';
import { useForm, useWatch } from "react-hook-form"
import * as XLSX from 'xlsx';
import { Box, Typography } from '@mui/joy';
import Previewer from './Previewer';
import { useTranslation } from 'react-i18next';
import { Button, Input, Text } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { XMLParser } from 'fast-xml-parser';

import JSONPretty from 'react-json-pretty';

import { Stepper, Step, StepLabel, Alert } from '@mui/material';

import * as forge from 'node-forge';
import * as asn1js from 'asn1js';
import { useXMLFlattener } from './XMLFlattener';
import { useXMLMapping } from './XMLMapping';
import WidgetDocumentPreview from 'src/mtska-frontend-app-component/components/FormElements/WidgetDocumentPreview';
import Constants from './Constants';

const ImporterFileMappingConstants = ({ dataProviderName, uid, handleClose, filters, externalDefaultMapping = {}, externalDefaultConstants = [], externalSetForwardDisabled, externalSetBackDisabled, externalSetActionInvoked, externalSetActionLabel, externalSetErrorMessage, actionInvoked }) => {

    const steps = ['Import file', 'Handle mapping', 'Handle constants'];
    const [activeStep, setActiveStep] = useState(0);

    const { t } = useTranslation();
    const { item: config } = useDataProvider('configs/config');
    const { save: saveImport, loadAll, errorMessage, errors, success } = useDataProvider('importer/file', true);
    const { loadAll: loadMappings, items: mappingsDb } = useDataProvider('imports/mapping');
    const { flattenItalianInvoiceXml } = useXMLFlattener();
    const { mapItalianInvoiceXml } = useXMLMapping();


    const [excelFile, setExcelFile] = useState(null);
    const [pdfFile, setPdfFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);

    const [xmlFile, setXmlFile] = useState(null);
    const [error, setError] = useState(null);

    const [dataType, setDataType] = useState(null);
    const [data, setData] = useState(null);

    const [editing, setEditing] = useState(false);
    const [mapping, setMapping] = useState({});
    const [constants, setConstants] = useState({});

    const [selectedMapping, setSelectedMapping] = useState();
    const [defaultMapping, setDefaultMapping] = useState(externalDefaultMapping);
    const [defaultConstants, setDefaultConstants] = useState(externalDefaultConstants);

    const [selectedMappingNewName, setSelectedMappingNewName] = useState('');
    const [createCopy, setCreateCopy] = useState();

    const [model, setModel] = useState();
    const [mappings, setMappings] = useState({});

    useEffect(() => {
        if (!Array.isArray(mappingsDb) || mappingsDb.length === 0) return;

        setMappings((prevMappings) => {
            const mappingValues = mappingsDb.reduce((a, v) => {
                return { ...a, [v.name]: v.mapping };
            }, {});

            // Controlla se i valori di mapping sono effettivamente cambiati
            if (JSON.stringify(prevMappings) !== JSON.stringify(mappingValues)) {
                return mappingValues;
            }
            return prevMappings;
        });
    }, [mappingsDb]);

    useEffect(() => {
        loadMappings(filters);
    }, []);

    useEffect(() => {
        externalSetErrorMessage(errorMessage);
        externalSetForwardDisabled(false)
    }, [errorMessage]);

    useEffect(() => {
        if (typeof config?.data?.modules === 'undefined') return;
        if (typeof config.data.modules[dataProviderName] === 'undefined') return;
        setModel(config.data.modules[dataProviderName].importModel);
    }, [config, dataProviderName])

    const form = useRef();
    const { handleSubmit, control, setValue, getValues } = useForm();

    const selectedMappingNewNameWatcher = useWatch({
        control,
        name: 'selectedMappingNewName'
    });

    const selectedMappingWatcher = useWatch({
        control,
        name: 'selectedMapping'
    });

    const createCopyWatcher = useWatch({
        control,
        name: 'createCopy'
    });

    const selectedFileWatcher = useWatch({
        control,
        name: 'fileUploader'
    });

    useEffect(() => {
        setSelectedMappingNewName(selectedMappingNewNameWatcher);
    }, [selectedMappingNewNameWatcher])

    useEffect(() => {
        handleSelectedMapping(selectedMappingWatcher);
    }, [selectedMappingWatcher])

    useEffect(() => {
        setCreateCopy(createCopyWatcher)
    }, [createCopyWatcher])

    useEffect(() => {
        if (actionInvoked == 0) {
            return;
        }

        let currentStep = activeStep;
        const totalSteps = steps.length - 1;

        if (actionInvoked > 0 && currentStep < totalSteps) {
            //console.info('actionInvoked', actionInvoked > 0 ? 'avanti' : 'indietro', currentStep + 1, totalSteps)
            currentStep += 1
            setActiveStep(currentStep);
            externalSetActionInvoked(0);
        } else if (actionInvoked > 0 && currentStep == totalSteps) {
            //console.info('actionInvoked', actionInvoked > 0 ? 'avanti' : 'indietro', currentStep, totalSteps)
            //alert('submit');
            handleSubmit(handleFileSubmit)();
            externalSetActionInvoked(0);

        } else if (actionInvoked < 0) {
            //console.info('actionInvoked', actionInvoked > 0 ? 'avanti' : 'indietro', currentStep - 1, totalSteps)
            currentStep -= 1
            setActiveStep(currentStep);
            externalSetActionInvoked(0);
        }

        if (currentStep == totalSteps) {
            externalSetActionLabel("Submit")
        } else {
            externalSetActionLabel("Next")
        }

        if (currentStep == 0) {
            externalSetBackDisabled(true)
        } else {
            externalSetBackDisabled(false)
        }

    }, [actionInvoked])


    useEffect(() => {
        if (document.querySelector('[name="fileUploader"]') === null) {
            return;
        }

        handleFile(document.querySelector('[name="fileUploader"]').files[0]);
    }, [selectedFileWatcher])

    useEffect(() => {
        if (excelFile !== null) {
            const workbook = XLSX.read(excelFile, {
                type: 'buffer',
                codepage: 65001, // Assicura la lettura con codifica UTF-8
                // cellText:false, 
                //cellDates:true,
                raw: true,
            });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            // https://docs.sheetjs.com/docs/api/utilities/array#array-output
            const data = XLSX.utils.sheet_to_json(worksheet, {
                defval: "",
                raw: false,
                // dateNF: 'DD"/"MM"/"yyyy', 
                // strip: false, 
                blankrows: true
            });

            setDataType('xls');
            setData(data);
            setActiveStep(1);
            externalSetBackDisabled(false);
            ////externalSetForwardDisabled(false)
        }
    }, [excelFile])

    useEffect(() => {
        if (!xmlFile) return;

        // Convert ArrayBuffer to string
        const decoder = new TextDecoder("utf-8");
        const xmlString = decoder.decode(xmlFile);

        // Parse XML using fast-xml-parser
        const parser = new XMLParser();
        const jsonData = parser.parse(xmlString);

        let jsonFlatData;
        let jsonMapping;
        switch (true) {
            case jsonData.hasOwnProperty('FatturaElettronica'):
                jsonFlatData = flattenItalianInvoiceXml(jsonData.FatturaElettronica);
                jsonMapping = mapItalianInvoiceXml();
                setDefaultMapping(jsonMapping);
                break;
            case jsonData.hasOwnProperty('ns3:FatturaElettronica'):
                jsonFlatData = flattenItalianInvoiceXml(jsonData['ns3:FatturaElettronica']);
                jsonMapping = mapItalianInvoiceXml();
                setDefaultMapping(jsonMapping);
                break;
            case jsonData.hasOwnProperty('p:FatturaElettronica'):
                jsonFlatData = flattenItalianInvoiceXml(jsonData['p:FatturaElettronica']);
                jsonMapping = mapItalianInvoiceXml();
                setDefaultMapping(jsonMapping);
                break;
        }

        if (!jsonFlatData) {
            return;
        }

        setDataType('xml');
        setData(jsonFlatData);
        setActiveStep(1);
        externalSetBackDisabled(false);
        //externalSetForwardDisabled(false)

    }, [xmlFile])

    // --------
    // CARICAMENTO DEL FILE
    // --------
    const handleFile = (selectedFile) => {
        const validMIMExls = ['application/vnd.ms-excel', 'text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const validMIMExml = ['text/xml'];
        const validMIMEpdf = ['application/pdf'];

        if (selectedFile && validMIMExls.includes(selectedFile.type)) {
            resetFiles()

            const url = URL.createObjectURL(selectedFile)
            const uplFile = { extension: selectedFile.name.split('.').pop().toLowerCase(), file: selectedFile, url }
            setUploadedFile(uplFile)

            const reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload = (e) => {
                setExcelFile(e.target.result);
            }

            setValue('filename', selectedFile.name);
        } else if (selectedFile && validMIMExml.includes(selectedFile.type)) {
            resetFiles()

            const reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload = (e) => {
                setXmlFile(e.target.result);
            }

            setValue('filename', selectedFile.name);
        } else if (selectedFile && selectedFile.name.split('.').pop().toLowerCase() === 'p7m') {
            resetFiles(t('P7M file detected'))

            const reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload = (e) => {
                setError(t('Parsing P7M file'));

                //const uint8Array = new Uint8Array(e.target.result);
                parseP7MFile(e.target.result);
            };

            setValue('filename', selectedFile.name);
        } else if (selectedFile && validMIMEpdf.includes(selectedFile.type)) {
            resetFiles()
            const url = URL.createObjectURL(selectedFile)
            const pdfFile = { extension: 'pdf', file: selectedFile, url }
            setPdfFile(pdfFile)
            setValue('filename', selectedFile.name)
            setData(pdfFile)
            setDataType('pdf')
            setActiveStep(1);
            externalSetBackDisabled(false);
            //externalSetForwardDisabled(false)
        } else {
            const error = selectedFile ? t('Import source file must be a valid file type (xls, xlsx, csv, xml, pdf)') : null
            resetFiles(error)
        }
    }

    const resetFiles = (error = null) => {
        setError(error)
        setExcelFile(null)
        setUploadedFile(null)
        setXmlFile(null)
        setPdfFile(null)
    }

    const parseP7MFile = (buffer) => {
        const binaryString = new TextDecoder().decode(buffer)

        // Cerca la prima apertura di un tag <FatturaElettronica> con qualsiasi namespace
        const xmlMatch = binaryString.match(/<[\w:]*FatturaElettronica[\s\S]*<\/[\w:]*FatturaElettronica>/)

        if (!xmlMatch) {
            setError('Nessun XML valido trovato nel file.')
            return
        }

        // Estrai la parte XML trovata
        const xmlString = xmlMatch[0].trim()

        try {
            // Analizza l'XML con DOMParser
            const parser = new DOMParser()
            const xmlDoc = parser.parseFromString(xmlString, 'text/xml')

            // Controlla se c'è un errore di parsing
            if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
                setError('Errore nel parsing dell\'XML. Il file potrebbe essere corrotto.')
                return
            }

            // Convertire l'XML pulito in ArrayBuffer e salvarlo nello stato
            const encoder = new TextEncoder()
            const mtfkr = encoder.encode(xmlString).buffer
            setXmlFile(mtfkr)
            setError(null)
        } catch (error) {
            setError('Errore durante l\'elaborazione del file.')
        }
    }

    // --------
    // GESTIONE DEI DUE STATI DI SUBMIT DELLA FORM
    // --------
    const handleFileSubmit = (formdata) => {
        if (pdfFile) {
            const { file } = pdfFile
            const data = new FormData()

            data.append('file', file)
            data.append('model', dataProviderName)
            data.append('mapping', false)
            data.append('excelData', false)

            setEditing(true)
            saveImport(data).then((data) => handleClose(uid, data.item.data)).catch(() => console.error('catch submit'))

            externalSetForwardDisabled(true)
        } else if (uploadedFile == null) {
            setError(t('Missing file'));
        } else if (Object.keys(mapping).length === 0) {
            setError(t('At least one column must be associated to a destinationfield'));
        } else {
            console.log("formdata", formdata);
            const { file } = uploadedFile;
            const data = new FormData()
            data.append('file', file)
            data.append('model', dataProviderName)
            data.append('mappingId', formdata.selectedMapping ?? "");
            data.append('mappingName', formdata.selectedMappingNewName ?? "");
            data.append('mappingCreateCopy', formdata.createCopy);
            data.append('mappingMapping', JSON.stringify(formdata.mapping));
            data.append('mappingConstants', JSON.stringify(formdata.constants.filter((constant) => constant.field !== "" && constant.value !== "")));


            setEditing(true)
            saveImport(data).then((data) => handleClose(uid, data.item.data)).catch(() => console.error('catch submit'))

            externalSetForwardDisabled(true)
        }
    }

    // --------
    // SELEZIONE DI UNA RICETTA DI MAPPING ESISTENTE
    // la selezione di un mapping esistente deve resettare eventuali mapping manuali e caricare lo schema desiderato
    // --------
    const handleSelectedMapping = (v) => {

        const newDefaultMapping = getMappingFromId(v);
        if (typeof newDefaultMapping === 'undefined') {
            setSelectedMapping(null);
            setDefaultMapping({});
            setDefaultConstants([]);
            setValue('createCopy', 'false')
            return;
        }

        setSelectedMapping(v);
        setDefaultMapping(getMappingFromId(v).mapping ?? {})
        setDefaultConstants(getMappingFromId(v).constants ?? [])
    }

    const getMappingsOptions = () => {
        const options = Object.keys(mappingsDb).length > 0 ? Object.values(mappingsDb).map((v, k) => {
            return { value: v.id, label: v.fullName };
        }) : []
        return options;
    }

    const getMappingFromId = (id) => {
        return mappingsDb.find(obj => {
            return obj.id === id
        })
    }

    const handleOnMappingChange = (newMapping) => {
        setValue('mapping', newMapping);
        setMapping(newMapping);
    }

    const handleOnConstantsChange = (newConstants) => {
        setValue('constants', newConstants);
        setConstants(newConstants);
    }

    const validateStep = (index) => {

        switch (index) {
            case 0:
                if (uploadedFile === null && activeStep > 0) {
                    setTimeout(() => setError(t('Missing file')), 500);
                    return t('Missing file')
                }
                break;
            case 1:
                if (Object.keys(mapping).length === 0 && activeStep > 1) {
                    setTimeout(() => setError(t('At least one column must be associated to a destinationfield')), 500);
                    return t('At least one column must be associated to a destinationfield')
                }
                break;
            default:
        }

        return false;
    }

    return (
        <Box className="importer">

            {error && (
                <Alert sx={{ marginBottom: '15px' }} severity="error">{error}</Alert>
            )}

            <Stepper activeStep={activeStep} sx={{ marginBottom: '40px', marginTop: '10px' }}>
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    const stepError = validateStep(index);
                    if (stepError) {
                        labelProps.optional = (
                            <Typography variant="caption" color="error">
                                {stepError}
                            </Typography>
                        );

                        labelProps.error = true;
                    }
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{t(label)}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>

            <Box className="importer-form-wrapper">

                <Box ref={form} className="importer-form">
                    {/* 
                        <Box className="import-stage">
                            VALUES:
                            <JSONPretty data={JSON.stringify(getValues())} className="json-wrapper" style={{fontSize:'0.6em'}}></JSONPretty>
                        </Box> 
                     */}
                    <Input
                        type="hidden"
                        name="mapping"
                        defaultValue={JSON.stringify(mapping)}
                        control={control}
                        editing={true}
                    />
                    <Input
                        type="hidden"
                        name="constants"
                        defaultValue={JSON.stringify(constants)}
                        control={control}
                        editing={true}
                    />

                    <Input
                        type="hidden"
                        name="filename"
                        defaultValue={null}
                        control={control}
                        editing={true}
                    />

                    <Box className={activeStep === 0 ? 'import-stage' : 'import-stage import-stage-hidden'}>
                        <Text level={"title-md"} className="sectionTitle">{t('Select a file to be imported')}</Text>
                        <Input
                            label={'Upload a file'}
                            type="file"
                            name="fileUploader"
                            control={control}
                            editing={true}
                            multiple={false}
                        />
                    </Box>

                    <Box className={activeStep === 1 && data && dataType == 'xls' ? 'import-stage' : 'import-stage import-stage-hidden'}>
                        <Text level={"title-md"} className="sectionTitle">{t('Select an existing mapping to be applied')} </Text>

                        <Box className="import-actions">
                            {mappings && Object.keys(mappings).length > 0 && (
                                <Input
                                    label={'Apply saved mapping'}
                                    type="select"
                                    name="selectedMapping"
                                    control={control}
                                    editing={true}
                                    addEmptyOption={true}
                                    options={getMappingsOptions()}
                                    translateOptions={false}
                                />
                            )}
                            {
                                selectedMapping && (
                                    <Input
                                        label={'Create a copy of mapping'}
                                        type="select"
                                        name="createCopy"
                                        control={control}
                                        editing={true}
                                        addEmptyOption={true}
                                        options={
                                            [
                                                { value: 'false', label: t('no') },
                                                { value: 'true', label: t('yes') }
                                            ]
                                        }
                                        translateOptions={false}
                                    />
                                )
                            }
                            <Input
                                label={selectedMapping && createCopy === 'true' ? 'Copy mapping with name' : (selectedMapping) ? 'Rename mapping as' : 'Save mapping as'}
                                type="text"
                                name="selectedMappingNewName"
                                control={control}
                                editing={true}
                            />

                        </Box>

                        <Previewer
                            data={data}
                            model={model}
                            defaultMapping={defaultMapping}
                            onMappingChange={handleOnMappingChange}
                            limit={10}
                        />
                    </Box>

                    <Box className={activeStep === 1 && data && dataType == 'pdf' ? 'import-stage' : 'import-stage import-stage-hidden'}>
                        <Text level={"title-md"} className="sectionTitle">{t('Preview of the uploaded PDF')} </Text>
                        <WidgetDocumentPreview item={pdfFile} downloadable={false} />
                    </Box>

                    <Box className={activeStep === 2 && data && dataType == 'xls' ? 'import-stage' : 'import-stage import-stage-hidden'}>
                        <Text level={"title-md"} className="sectionTitle">{t('Define as many constant values you need to be assigned to each single row')} </Text>
                        <Text level={"title-sm"} style={{ fontWeight: '300', marginBottom: '30px' }}>{t('Any row containing a value for the given constant field will override the constant')} </Text>

                        <Constants
                            model={model}
                            control={control}
                            defaultConstants={defaultConstants}
                            onConstantsChange={handleOnConstantsChange}
                            setValue={setValue}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default ImporterFileMappingConstants;